import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for the revenue module in Redux.
 */
const initialState = {
    revenueData: null,               // Stores revenue-related data (e.g. graph or analytics info)
    revenuePath: '/financialinsights', // Default route path for financial insights section,
    txnReqList:null, 
};

/**
 * Redux slice for handling revenue and financial insights state.
 * 
 * Includes reducers to update revenue data and path.
 */
const revenueSlice = createSlice({
    name: 'revenue',
    initialState,
    reducers: {
        /**
         * Set or update the revenue data.
         * @param {Object} state 
         * @param {Object} action - New revenue data (array, object, etc.)
         */
        setRevenueData: (state, action) => {
            state.revenueData = action.payload;
        },

        /**
         * Set the current revenue path for routing/navigation purposes.
         * @param {Object} state 
         * @param {Object} action - Path string.
         */
        setRevenuePath: (state, action) => {
            state.revenuePath = action.payload;
        },
        setTxnReqList:(state, action)=>{
            state.txnReqList=action.payload;
        }
    },

    /**
     * Optional reducer to reset state globally using a plain string action.
     * (Consider replacing this with a formal action as shown below.)
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Exporting action creators
export const { setRevenueData, setRevenuePath, setTxnReqList } = revenueSlice.actions;

// Exporting the reducer to be added in the Redux store
export default revenueSlice.reducer;
